// src/components/common/RouteAlert.js

import { Box, HStack, Image, Text } from "@chakra-ui/react";
import { useUITheme } from "../../context/ThemeContext";
import trippaLogo from "../../assets/images/logo_classic.png";

const MESSAGES = {
  shortened: { title: "Trippa adjusted your itinerary", body: "We shortened the route because there weren't enough suitable stops nearby.", hint: "Try a wider search area to include more options.", tone: "#d97706" },
  "non-viable": { title: "Trippa couldn't connect that route", body: "Those choices don't currently make a practical itinerary.", hint: "Try fewer stops, a wider search area, or another transport mode.", tone: "#e11d48" },
  "missing-inputs": { title: "Your route needs two places", body: "Choose both a start and finish location before building your itinerary.", tone: "#d97706" },
  "missing-location": { title: "Choose your tour area", body: "Drop a pin or choose your current location before building a local tour.", tone: "#d97706" },
  "missing-stops": { title: "Choose something to discover", body: "Add at least one type of stop to your itinerary.", tone: "#d97706" },
  "geocode-failed": { title: "Trippa couldn't find that place", body: "Check the location and try choosing it again from the suggestions.", tone: "#e11d48" },
  "places-failed": { title: "Trippa couldn't find enough stops", body: "There aren't enough suitable places nearby for this combination.", hint: "Try fewer stops, different interests, or a wider search area.", tone: "#e11d48" },
};

function RouteAlert({ error }) {
  const theme = useUITheme();
  const message = MESSAGES[error];
  if (!message) return null;

  return (
    <Box role={error === "shortened" ? "status" : "alert"} aria-live="polite" w="100%" border="1px solid" borderColor={`${message.tone}55`} borderLeftWidth="4px" borderLeftColor={message.tone} borderRadius="xl" bg={theme.bg} boxShadow="0 8px 24px rgba(15, 23, 42, 0.08)" px={4} py={3}>
      <HStack align="flex-start" spacing={3}>
        <Box flexShrink={0} boxSize="38px" borderRadius="full" bg={`${theme.primary}14`} display="grid" placeItems="center">
          <Image src={trippaLogo} alt="" boxSize="30px" objectFit="contain" />
        </Box>
        <Box minW={0}>
          <Text fontSize="sm" fontWeight="extrabold" color={theme.text}>{message.title}</Text>
          <Text mt={0.5} fontSize="sm" color={theme.text} opacity={0.75}>{message.body}</Text>
          {message.hint && <Text mt={1.5} fontSize="xs" fontWeight="bold" color={message.tone}>{message.hint}</Text>}
        </Box>
      </HStack>
    </Box>
  );
}

export default RouteAlert;
